import { useMemo, useCallback } from 'react';
import type { EventHandlers } from '@atlassian/jira-native-issue-table/src/common/types.tsx';
import { useOnIssueKeyChange } from '@atlassian/jira-issue-context-service/src/main.tsx';

export const useEventHandlers = (currentIssueKey: string): EventHandlers => {
	const onIssueKeyChanged = useOnIssueKeyChange();
	const onIssueLinkSelected = useCallback(
		(issueKey: string): boolean => {
			onIssueKeyChanged &&
				onIssueKeyChanged({ fromIssueKey: currentIssueKey, toIssueKey: issueKey });
			return !!onIssueKeyChanged;
		},
		[currentIssueKey, onIssueKeyChanged],
	);

	return useMemo(
		() => ({
			onIssueLinkSelected,
		}),
		[onIssueLinkSelected],
	);
};
